import { Deserializable } from '../protocols/deserializable';
import { MemberRetirementTypeIdEnum } from './enum/member-retirement-type-id.enum';
import { RetirementType } from './retirement-type';
import { MemberRetirementStubHistory } from './member-retirement-stub-history';

export class MemberRetirementStub implements Deserializable {
  public id!: number;
  public memberId!: number;
  public retirementTypeId!: MemberRetirementTypeIdEnum;
  public retirementType!: RetirementType;
  public effectiveDate!: string;
  public retirementStubHistory: MemberRetirementStubHistory[] = [];

  public onDeserialize(): void {
    if (this.retirementStubHistory?.length) {
      this.retirementStubHistory = window?.injector?.Deserialize?.arrayOf(
        MemberRetirementStubHistory,
        this.retirementStubHistory
      );
    }
  }
}
